var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.done)?_c('PwFormFinishedView',[_vm._v("パスワードを再設定しました。")]):(_vm.error)?_c('PwFormFinishedView',[_vm._v("URLが不正です。")]):_c('PwChangeFormView',{attrs:{"loading":_vm.loading},on:{"request":_vm.request,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }